import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ChaptersState {
  parentChapterIndex: number | null;
}

const initialState: ChaptersState = {
  parentChapterIndex: null,
};

const chaptersSlice = createSlice({
  name: 'chapters',
  initialState,
  reducers: {
    setParentChapterIndex: (state, action: PayloadAction<number | null>) => {
      return { ...state, parentChapterIndex: action.payload };
    },
  },
});

export const { setParentChapterIndex } = chaptersSlice.actions;

export const { reducer: chaptersReducer } = chaptersSlice;
